import { Outlet, useOutletContext } from 'react-router-dom';

function ViewProjectsList() {
    const outletContext = useOutletContext();
    
    return (
        <div className="">
            <Outlet context={outletContext} />
        </div>
    );
}

export default ViewProjectsList;
